import styled from "styled-components";

const IMAGE_GAP = 8;

export const DicomImages = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${IMAGE_GAP}px;
  width: 100%;
  margin-top: 48px;
`;

export const ImageWrapper = styled.div`
  flex: 0 1 auto;

  img {
    max-height: 400px;
    max-width: 100%;
    width: auto;
  }
`;
